import { render, staticRenderFns } from "./BackTitle.vue?vue&type=template&id=b403a4f0&scoped=true&"
import script from "./BackTitle.vue?vue&type=script&lang=js&"
export * from "./BackTitle.vue?vue&type=script&lang=js&"
import style0 from "./BackTitle.vue?vue&type=style&index=0&id=b403a4f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b403a4f0",
  null
  
)

export default component.exports